"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsurableItemMetadata = void 0;
var next_api_swr_1 = require("@newfront-insurance/next-api-swr");
var react_1 = require("react");
var routes_1 = require("../bff/routes");
var provider_1 = require("../provider");
function useInsurableItemMetadata(params, config) {
    var _a, _b;
    var basePath = react_1.useContext(provider_1.CoverageApiContext).basePath;
    return next_api_swr_1.useNextApiSubscription(routes_1.routes.insurableItemMetadata.getUrl(__assign(__assign({}, params), { insurableItemVersion: (_b = (_a = params.insurableItemVersion) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : undefined }), basePath), config);
}
exports.useInsurableItemMetadata = useInsurableItemMetadata;
